import { IChannelCategoryRepository } from '../../ports/IChannelCategoryRepository';

export class ListChannelCategoriesUseCase {
  constructor(private repo: IChannelCategoryRepository) {}
  execute() {
    return this.repo.list();
  }
}
